<template>
  <div>
    <el-dialog
      title="查看材料"
      width="880px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-row v-if="!(!checkAdmin() && materialsAuditStatus === 1)" type="flex" class="info-line">
        <p class="label">当前状态：</p>
        <p class="value">
          <template v-if="materialsAuditStatus === 1">审核中</template>
          <template v-else-if="materialsAuditStatus === 2">审核通过</template>
          <template v-else-if="materialsAuditStatus === 3">驳回</template>
          <template v-else-if="materialsAuditStatus === 9">不需要审核</template>
          <template v-else> -- </template>
        </p>
      </el-row>
      <el-row type="flex" class="info-line">
        <p class="label">未成年人参训申请材料：</p>
        <p class="value"><a href="javascript:;" @click="toViewDoc">查看文件</a></p>
      </el-row>
      <template v-if="!(!checkAdmin() && materialsAuditStatus === 1)">
        <p class="module-title">【审核记录】</p>
        <el-table v-loading="loading" :data="data" style="width:100%;" border >
          <el-table-column label="审核人" width="140" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.auditorName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核操作" width="140" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.auditStatus === 1">审核通过</span>
              <span v-else-if="row.auditStatus === 2">审核驳回</span>
              <span v-else> -- </span>
            </template>
          </el-table-column>
          <el-table-column label="审核时间" minWidth="160" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.lastUpdateDate || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="驳回原因" minWidth="160" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.reason"
                :disabled="row.reason.length < 30"
                :open-delay="200"
                placement="top"
              >
                <div slot="content" class="tooltip-content">{{ row.reason }}</div>
                <span class="tooltip-index">{{ row.reason | formatTooltipString }}</span>
              </el-tooltip>
              <span v-else> -- </span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <span slot="footer" class="dialog-footer">
        <template v-if="!orderId && materialsAuditStatus === 1">
          <el-button type="primary" size="small" @click="handleConfirm">审核通过</el-button>
          <el-button size="small" @click="handleReject">审核驳回</el-button>&emsp;
        </template>
        <el-button size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审核驳回"
      width="480px"
      :visible.sync="dialogRejectVisible"
      :before-close="handleCloseReject"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="rejectFormEl" :model="rejectForm" :rules="rules" label-width="100px">
        <el-form-item label="驳回原因：" prop="reason">
          <el-input v-model="rejectForm.reason" type="textarea" :rows="3" maxlength="500" placeholder="请输入驳回原因" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleConfirmReject">确认驳回</el-button>
        <el-button size="small" @click="handleCloseReject">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserMaterials,
  userMaterialsAuditList,
  userMaterialsAudit
} from "@/api/orderAdmin/orderList";

export default {
  name: 'MaterialsInfo',

  data () {
    return {
      dialogVisible: false,
      loading: false,
      orderId: '',
      infoId: '',
      materialsAuditStatus: 0,
      applyMaterials: '',
      data: [],
      dialogRejectVisible: false,
      rejectForm: {
        reason: ''
      },
      rules: {
        reason: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (payload) {
      if (payload.orderId) {
        this.orderId = payload.orderId
        this.handleGetUserMaterials()
      } else {
        this.infoId = payload.infoId
        this.materialsAuditStatus = payload.materialsAuditStatus
        this.applyMaterials = payload.applyMaterials
        this.handleGetuserMaterialsAuditList()
      }
      this.dialogVisible = true
    },
    handleGetUserMaterials () {
      const params = { orderId: this.orderId }
      getUserMaterials(params).then(({ code, data }) => {
        if (code === 0 && data) {
          this.infoId = data.id
          this.materialsAuditStatus = data.materialsAuditStatus
          this.applyMaterials = data.applyMaterials
          this.handleGetuserMaterialsAuditList()
        }
      })
    },
    handleGetuserMaterialsAuditList () {
      const params = {
        infoId: this.infoId,
        limit: 9999,
        page: 1
      }
      userMaterialsAuditList(params).then(({ code, data }) => {
        if (code === 0) {
          this.data = data.records
        }
      })
    },
    toViewDoc () {
      window.open(this.applyMaterials)
    },
    handleConfirm () {
      const params = {
        infoId: this.infoId,
        status: 1
      }
      userMaterialsAudit(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success('审核通过!')
          this.handleClose()
          this.handleCloseReject()
          this.$parent.handleGetListPage()
        }
      })
    },
    handleReject () {
      this.dialogRejectVisible = true
    },
    handleConfirmReject () {
      this.$refs.rejectFormEl.validate(valid => {
        this.$confirm('是否确认操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (valid) {
            const params = {
              infoId: this.infoId,
              reason: this.rejectForm.reason,
              status: 2
            }
            userMaterialsAudit(params).then(({ code }) => {
              if (code === 0) {
                this.$message.success('审核驳回成功!')
                this.handleClose()
                this.handleCloseReject()
                this.$parent.handleGetListPage()
              }
            })
          }
        })
      })
    },
    handleClose () {
      this.orderId = this.$options.data().orderId
      this.infoId = this.$options.data().infoId
      this.materialsAuditStatus = this.$options.data().materialsAuditStatus
      this.applyMaterials = this.$options.data().applyMaterials
      this.data = []
      this.dialogVisible = false
    },
    handleCloseReject () {
      this.rejectForm = this.$options.data().rejectForm
      this.$refs.rejectFormEl && this.$refs.rejectFormEl.resetFields()
      this.dialogRejectVisible = false
    }
  },
   filters: {
    formatTooltipString (val) {
      if (val) {
        if (val.length > 30) {
          return val.substring(0, 30) + '...'
        }
        return val
      }
      return '--'
    }
  },
}
</script>

<style lang="scss" scoped>
.info-line {
  padding: 8px 0;
  font-size: 14px;
  color: #333;
  .label {
    width: 170px;
    padding-right: 8px;
    text-align: right;
    white-space: nowrap;
  }
  .value {
    flex: 1;
  }
}
.module-title {
  padding: 18px 0 10px;
  font-size: 16px;
  color: #333;
}
.tooltip-content {
  max-width: 300px;
  word-break: break-all;
}
</style>
